var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { GetProductData, GetSectionData, LoadProductDataItems } from '@themes/common/data';
import { ArrayContains, ExtractUnits, GenerateInputsBaseFromUnits, GetProductPalletValues, GetValueByAction, HasVatDisplay, IsMobile, MmToCm, RoundOff, } from '@themes/common/utils';
import { GetDisplayUnit } from '@themes/common/display-units';
import clsx from 'clsx';
import ExtraProduct from './extra-products';
import { produce } from 'immer';
import debounce from 'lodash/debounce';
import { FormatMoney } from '@components/Shared/Utils/price';
import ExtraProductDisplay from './extra-products-display';
import useProductPage from '../useProductPage';
import ImportAxios from '@themes/common/axios';
import { stringify, parse } from 'qs';
import { StringReplaceCurlyBraces } from '@commons/replaceCurly';
import ProductGallery from '@themes/static-scripts/sb-empire/ProductGallery';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import CartService from '@themes/common/Cart/CartService';
const LoadedProducts = {};
const LoadedExtraProducts = {};
let isOptionSorted = false;
export const filterHorn = (productData) => ArrayContains(productData.tags, 'Poolsten:Hörn');
export const CalculatePoolQuantity = (inputs, product, extra_product_pool_corner, selectedPoolCorner) => {
    var _a, _b, _c;
    const productLength = MmToCm(parseFloat((_a = product.metafields['SB-P']['Length']) !== null && _a !== void 0 ? _a : '1'));
    let corner_size = 0;
    let additional_quantity = 0;
    if (!selectedPoolCorner) {
        corner_size = 0;
        additional_quantity = 4;
    }
    else if (!!extra_product_pool_corner && selectedPoolCorner) {
        const corner_length = MmToCm(parseFloat((_b = extra_product_pool_corner === null || extra_product_pool_corner === void 0 ? void 0 : extra_product_pool_corner.metafields['SB-P']['Length']) !== null && _b !== void 0 ? _b : '0'));
        const corner_width = MmToCm(parseFloat((_c = extra_product_pool_corner === null || extra_product_pool_corner === void 0 ? void 0 : extra_product_pool_corner.metafields['SB-P']['Width']) !== null && _c !== void 0 ? _c : '0'));
        corner_size = Math.abs(corner_length - corner_width) * 2;
    }
    const length = inputs.Length - corner_size;
    const width = inputs.Width - corner_size;
    const length_quantity = Math.ceil(length / productLength) * 2;
    const width_quantity = Math.ceil(width / productLength) * 2;
    const quantity = length_quantity + width_quantity + additional_quantity;
    return quantity > 0 ? quantity : 1;
};
function FormInput({ unit, id, field, value, loading, className, isCart, price, factorValue, onChange, onButtonClick, onBlur, hideButtons, minimumQuantity, }) {
    var _a, _b;
    let newValue = value ? parseFloat((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : '0') : 0;
    if (!isNaN(newValue)) {
        newValue = Math.round(newValue * 10) / 10;
    }
    value = isNaN(newValue) ? value : newValue;
    return (_jsx("div", Object.assign({ className: clsx('product-input-wrapper', className, {
            'cart-input': isCart,
        }) }, { children: isCart ? (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: 'title' }, { children: GetDisplayUnit(unit) })), _jsx("input", { id: id, step: 'any', type: 'number', value: (_b = value === null || value === void 0 ? void 0 : value.toString()) !== null && _b !== void 0 ? _b : '0', "aria-labelledby": GetDisplayUnit(unit), className: 'product-unit-input', onChange: (e) => onChange(field, e.currentTarget.value), onKeyUp: (e) => onChange(field, e.currentTarget.value), onPaste: (e) => onChange(field, e.currentTarget.value), onBlur: onBlur, disabled: loading, placeholder: '0', min: minimumQuantity }), !hideButtons && (_jsxs("div", Object.assign({ className: 'product-input-button-wrapper' }, { children: [_jsx("button", Object.assign({ tabIndex: -1, className: 'button-secondary product-unit-button-action minus', "data-action": 'minus', "data-input-id": 'product[properties][DefaultUnit]', type: 'button', onClick: () => onButtonClick(field, 'subtract'), disabled: loading }, { children: "-" })), _jsx("button", Object.assign({ tabIndex: -1, className: 'button-primary product-unit-button-action add', "data-action": 'add', "data-input-id": 'product[properties][DefaultUnit]', type: 'button', onClick: () => onButtonClick(field, 'add'), disabled: loading }, { children: "+" }))] })))] })) : (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: 'product-input-wrapper-container' }, { children: [_jsxs("div", Object.assign({ className: 'product-input-button-wrapper' }, { children: [!hideButtons && (_jsx("button", Object.assign({ tabIndex: -1, className: 'button-secondary product-unit-button-action minus', "data-action": 'minus', "data-input-id": 'product[properties][DefaultUnit]', type: 'button', onClick: () => onButtonClick(field, 'subtract'), disabled: loading }, { children: "-" }))), _jsx("input", { id: id, step: 'any', type: 'number', value: value, "aria-labelledby": GetDisplayUnit(unit), className: clsx('product-unit-input', {
                                    'without-button': hideButtons,
                                }), onChange: (e) => onChange(field, e.currentTarget.value), onKeyUp: (e) => onChange(field, e.currentTarget.value), onPaste: (e) => onChange(field, e.currentTarget.value), onBlur: onBlur, disabled: loading, placeholder: '0', min: minimumQuantity }), !hideButtons && (_jsx("button", Object.assign({ tabIndex: -1, className: 'button-primary product-unit-button-action add', "data-action": 'add', "data-input-id": 'product[properties][DefaultUnit]', type: 'button', onClick: () => onButtonClick(field, 'add'), disabled: loading }, { children: "+" }))), _jsx("div", Object.assign({ className: 'title' }, { children: GetDisplayUnit(unit) }))] })), price != undefined && factorValue != undefined && (_jsxs("div", Object.assign({ className: 'price-per-unit' }, { children: [_jsxs("span", { children: ["Pris per ", GetDisplayUnit(unit)] }), _jsx("span", { children: FormatMoney(price * factorValue) })] })))] })) })) })));
}
export const ProductSectionData = GetSectionData('static-product');
const ProductInput = ({ id: variantId, settings, product: productData, quantity = 1, minimumQuantity = 1, withPallets = true, inputChange, inputChangeDebounce, onBlur, children, loading, isCart, extraProducts: extraProductsData, variantInput, type: formInputType, }) => {
    var _a, _b, _c, _d;
    const previousVariantId = useRef(null);
    const [variantChangeLoading, setVariantChangeLoading] = useState(false);
    const [{ variantId: id, product, extraProducts, variants }, setProductPage] = useProductPage(variantId, quantity, extraProductsData, productData, isCart);
    const initialLoad = useRef(true);
    const [selectedPoolCorners, setSelectedPoolCorners] = useState((_a = (extraProducts !== null && extraProducts !== void 0 ? extraProducts : []).filter(filterHorn).map((m) => m.variant_id)) !== null && _a !== void 0 ? _a : []);
    const [selectedPoolCorner, setSelectedPoolCorner] = useState(((_b = (extraProducts !== null && extraProducts !== void 0 ? extraProducts : []).filter(filterHorn).map((m) => m.variant_id)) !== null && _b !== void 0 ? _b : []).length > 0);
    const [{ qty, rawQuantity, fields, areaFieds, inputs, pallets, breakingPallets, tippings }, setState] = useState({
        qty: quantity,
        rawQuantity: quantity,
        fields: [],
        areaFieds: [],
        pallets: 0,
        breakingPallets: 0,
        tippings: 0,
        inputs: {},
    });
    const price = useMemo(() => product.price, [product.price]);
    const [totalDisplay, setTotalDisplay] = useState(FormatMoney(price * qty, settings.money_format));
    const is_sample = product.tags.includes('sample');
    const bagSize = useMemo(() => { var _a; return parseFloat((_a = product.metafields['SB-P']['BagSize']) !== null && _a !== void 0 ? _a : '1'); }, [product.metafields]);
    const bagDensity = useMemo(() => { var _a; return parseFloat((_a = product.metafields['SB-P']['BagDensity']) !== null && _a !== void 0 ? _a : '1'); }, [product.metafields]);
    const isBags = useMemo(() => !!(product.metafields['SB-P']['BagSize'] && product.metafields['SB-P']['BagDensity']), [product.metafields]);
    const isPool = useMemo(() => !!(product.metafields['SB-P']['Length'] && product.metafields['SB-P']['Width'] && ArrayContains(product.tags, 'Poolsten:Rak')), [product.metafields, product.tags]);
    const isStair = useMemo(() => !!(product.metafields['SB-P']['Length'] && product.metafields['SB-P']['Width'] && ArrayContains(product.tags, 'stair-calculator')), [product.metafields, product.tags]);
    const extra_product_pool_corner = useMemo(() => (isPool ? extraProducts === null || extraProducts === void 0 ? void 0 : extraProducts.filter(filterHorn)[0] : null), [isPool, extraProducts]);
    const extra_product_pool_corners = useMemo(() => (extra_product_pool_corner ? [extra_product_pool_corner] : []), [extra_product_pool_corner]);
    const extra_products = useMemo(() => extraProducts.filter((f) => f.variant_id !== (extra_product_pool_corner === null || extra_product_pool_corner === void 0 ? void 0 : extra_product_pool_corner.variant_id)), [extra_product_pool_corner, extraProducts]);
    const type = useMemo(() => {
        if (formInputType) {
            return formInputType;
        }
        if (isPool) {
            return 'pool';
        }
        if (isBags) {
            return 'bag';
        }
        if (isStair) {
            return 'stair';
        }
        return 'default';
    }, [formInputType, isPool, isBags, isStair]);
    // Initialize product page set
    useEffect(() => {
        if (!isCart) {
            setProductPage((state) => {
                state.variantId = variantId;
                state.product = productData;
                state.extraProducts = extraProductsData;
                state.quantity = quantity;
            });
        }
    }, [variantId, productData, extraProductsData, quantity, setProductPage, isCart]);
    useEffect(() => {
        if (isCart || variants.length > 0) {
            return;
        }
        const fetchVariants = () => __awaiter(void 0, void 0, void 0, function* () {
            const axios = yield ImportAxios();
            const productUrl = globalThis.location.pathname;
            const search = new URLSearchParams('');
            search.set('view', 'sb-variants');
            const { data } = yield axios.get(`${productUrl}?${search.toString()}`);
            const swatches = jQuery('.variants-ui__option-swatch');
            for (const element of swatches) {
                const currentElement = jQuery(element);
                const product = data.find((data) => data.variant_options.includes(currentElement.attr('data-option-value')));
                if (product) {
                    jQuery(element).css('--background-image', `url(${product.image})`);
                }
            }
            LoadProductDataItems(data);
            setProductPage((state) => {
                state.variants = data;
            });
        });
        fetchVariants();
    }, [isCart, productData, productData.url, setProductPage, variants.length]);
    useEffect(() => {
        if (isCart) {
            return;
        }
        const element = jQuery(`[data-section-type="static-product"][data-section-data]`);
        if (!element.length) {
            return;
        }
        const section = jQuery(`#shopify-section-${element.data('section-id')}`);
        const priceContainer = section.find('[data-price-container]');
        const priceElement = section.find('[data-price-container] [data-price]');
        const compareAtPriceContainer = section.find('[data-price-compare-container]');
        const compareAtPriceElement = section.find('[data-price-compare-container] [data-price-compare]');
        const salesBadgeContainer = section.find('[data-badge-sales]');
        const onSale = Number(product.unit_price) < Number(product.unit_compare_at_price);
        priceElement.html(`${FormatMoney(product.unit_price)} <span class="sb-units"> / ${product.unit}</span>`);
        compareAtPriceElement.html(`${FormatMoney(product.unit_compare_at_price)} <span class="sb-units"> / ${product.unit}</span>`);
        compareAtPriceContainer.toggleClass('visible', onSale);
        priceContainer.toggleClass('price__current--on-sale', onSale);
        if (settings.product.sales_badge && onSale) {
            salesBadgeContainer.css('display', 'block');
            let saleBadge = settings.translations.product_price.badge.sale;
            if (settings.product.sales_badge_style === 'percent') {
                saleBadge = StringReplaceCurlyBraces(settings.translations.product_price.badge.sale_percentage_single_html, {
                    savings: Math.round(((product.unit_compare_at_price - product.unit_price) / product.unit_compare_at_price) * 100),
                });
            }
            else if (settings.product.sales_badge_style === 'money') {
                saleBadge = StringReplaceCurlyBraces(settings.translations.product_price.badge.sale_money_single_html, {
                    savings: `${FormatMoney(product.unit_compare_at_price - product.unit_price)} <span class="sb-units"> / ${product.unit}</span>`,
                });
            }
            salesBadgeContainer.html(saleBadge);
        }
        else {
            salesBadgeContainer.css('display', 'none');
        }
    }, [isCart, product, settings]);
    useEffect(() => {
        if (isCart || variants.length <= 1) {
            return;
        }
        const LoadProductVariantContents = (variant_id) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            const selectedProductVariant = variants === null || variants === void 0 ? void 0 : variants.find((v) => { var _a; return ((_a = v.variant_id) === null || _a === void 0 ? void 0 : _a.toString()) === (variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString()); });
            const productUrl = selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.url;
            const mainProductUrl = selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.main_product_url;
            const mainUrlIsInVariants = variants === null || variants === void 0 ? void 0 : variants.some((v) => v.url.split('?')[0] === (mainProductUrl === null || mainProductUrl === void 0 ? void 0 : mainProductUrl.split('?')[0]));
            const newProduct = GetProductData(variant_id);
            if (!newProduct) {
                return;
            }
            const form = jQuery('form[data-sb-product-form]');
            const formData = new FormData(form[0]);
            const id = formData.get('id');
            const productId = formData.get('product-id');
            if ((id === null || id === void 0 ? void 0 : id.toString()) !== (variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString()) || (productId === null || productId === void 0 ? void 0 : productId.toLowerCase()) !== ((_a = newProduct.product_id) === null || _a === void 0 ? void 0 : _a.toString())) {
                let inputId = form.find('input[name="id"]');
                let inputProductId = form.find('input[name="product-id"]');
                if (!inputId.length) {
                    inputId = jQuery(`<input type="hidden" name="id" value="${variant_id}" />`);
                    form.append(inputId);
                }
                else {
                    inputId.val(variant_id);
                }
                if (!inputProductId.length) {
                    inputProductId = jQuery(`<input type="hidden" name="product-id" value="${newProduct.product_id}" />`);
                    form.append(inputProductId);
                }
                else {
                    inputProductId.val(newProduct.product_id);
                }
                formData.set('id', variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString());
            }
            if (productUrl && mainUrlIsInVariants) {
                const productDetails = jQuery('[data-product-details]');
                const productTitle = productDetails.find('.product-title');
                productTitle.html(newProduct.title);
                const search = new URLSearchParams(productUrl.split('?')[1]);
                search.set('variant', variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString());
                const url = `${productUrl.split('?')[0]}?${search.toString()}`;
                window.history.replaceState(null, '', url);
            }
            setVariantChangeLoading(true);
            try {
                if (variant_id) {
                    const newProduct = GetProductData(variant_id);
                    const image_badges = (_b = globalThis.sbBadges) === null || _b === void 0 ? void 0 : _b.call(globalThis, newProduct, 'Product Gallery');
                    setProductPage((state) => {
                        state.variantId = variant_id;
                        state.product = newProduct;
                        state.quantity = 1;
                    });
                    if (!isOptionSorted && newProduct.options_with_values && newProduct.options_with_values.length > 0) {
                        const sortOptions = () => {
                            const swatchKing = jQuery('variant-swatch-king');
                            if (swatchKing.length > 0) {
                                for (const { name, values } of newProduct.options_with_values) {
                                    const option = swatchKing.find(`[option-name="${name}"]`);
                                    if (option.length > 0) {
                                        const swatchView = option.find('ul.swatch-view');
                                        const swatches = swatchView.children();
                                        for (const value of values) {
                                            const swatch = swatches.filter(`[orig-value="${value}"]`);
                                            if (swatch.length > 0) {
                                                swatch.appendTo(swatchView);
                                            }
                                        }
                                    }
                                }
                                isOptionSorted = true;
                            }
                            else {
                                setTimeout(sortOptions, 200);
                            }
                        };
                        sortOptions();
                    }
                    const axios = yield ImportAxios();
                    const search = Object.assign({}, ((_c = parse(newProduct.url.split('?')[1])) !== null && _c !== void 0 ? _c : {}));
                    const path = newProduct.url.split('?')[0];
                    const loadExtraProducts = () => __awaiter(void 0, void 0, void 0, function* () {
                        const extraProductPath = `${path}?${stringify(Object.assign(Object.assign({}, search), { view: 'sb-extra-json' }))}`;
                        let extraProducts = LoadedExtraProducts[extraProductPath];
                        if (!extraProducts) {
                            const { data } = yield axios.get(extraProductPath);
                            extraProducts = data;
                            LoadedExtraProducts[extraProductPath] = data;
                        }
                        LoadProductDataItems(extraProducts !== null && extraProducts !== void 0 ? extraProducts : []);
                        setProductPage((state) => {
                            state.extraProducts = extraProducts !== null && extraProducts !== void 0 ? extraProducts : [];
                        });
                    });
                    const loadProductVariant = () => __awaiter(void 0, void 0, void 0, function* () {
                        var _e, _f, _g, _h, _j, _k;
                        const productVariantPath = `${path}?${stringify(search)}`;
                        let htmlString = LoadedProducts[productVariantPath];
                        if (!htmlString) {
                            const { data } = yield axios.get(productVariantPath);
                            htmlString = data;
                            LoadedProducts[productVariantPath] = data;
                        }
                        const htmlContents = jQuery(htmlString);
                        const lipscoreRating = htmlContents.find('.shopify-block.shopify-app-block');
                        const tabs = htmlContents.find('.shopify-section.tabs--container');
                        const recommendations = htmlContents.find('.shopify-section.sb-recommendation--container');
                        const galleries = htmlContents.find('.shopify-section.product-gallery--container');
                        const containers = [...tabs, ...recommendations, ...galleries, ...lipscoreRating];
                        for (const containerElement of containers) {
                            const container = jQuery(containerElement);
                            const existingContainer = jQuery(`#${containerElement.id}`);
                            const maxHeight = existingContainer.height();
                            existingContainer.css('min-height', `${maxHeight}px`);
                            const galleryImage = container.find('.product-gallery--image');
                            if (galleryImage.length) {
                                galleryImage.append(image_badges);
                            }
                            jQuery(`#${containerElement.id}`).html(container.html());
                        }
                        htmlContents.find('#shopify-section-sb-product-badges .sb-badge--list').appendTo('.sb-product-badges-block');
                        (_e = globalThis.initializeTabs) === null || _e === void 0 ? void 0 : _e.call(globalThis);
                        (_f = globalThis.initializeFitBlock) === null || _f === void 0 ? void 0 : _f.call(globalThis);
                        (_g = globalThis.initializeSbModal) === null || _g === void 0 ? void 0 : _g.call(globalThis);
                        (_h = globalThis.initializeAlgoliaRecommendation) === null || _h === void 0 ? void 0 : _h.call(globalThis);
                        (_k = (_j = globalThis.rimg_shopify) === null || _j === void 0 ? void 0 : _j.init) === null || _k === void 0 ? void 0 : _k.call(_j, '[data-rimg="lazy"]', {
                            round: 1,
                        });
                        if (ProductSectionData) {
                            new ProductGallery({
                                el: jQuery('[data-product-gallery]')[0],
                                sectionContext: null,
                                settings: ProductSectionData.settings,
                                isQuickshop: null,
                            });
                        }
                    });
                    yield loadExtraProducts();
                    yield loadProductVariant();
                }
            }
            catch (_d) { }
            setVariantChangeLoading(false);
        });
        const changeEvent = (e) => {
            if (e instanceof CustomEvent) {
                const variant_id = e.detail.currentVariant.id;
                if (previousVariantId.current !== variant_id) {
                    previousVariantId.current = variant_id;
                    LoadProductVariantContents(variant_id);
                }
            }
        };
        globalThis.addEventListener('shopify-variants:switch-variant', changeEvent);
        const Initialize = () => __awaiter(void 0, void 0, void 0, function* () {
            var _l;
            if (previousVariantId.current) {
                return;
            }
            const search = new URLSearchParams(window.location.search);
            const variant_id = (_l = search.get('variant')) !== null && _l !== void 0 ? _l : id;
            previousVariantId.current = variant_id;
            yield LoadProductVariantContents(variant_id);
        });
        const InitializeDebounce = debounce(Initialize, 200);
        InitializeDebounce();
        return () => {
            InitializeDebounce.cancel();
            globalThis.removeEventListener('shopify-variants:switch-variant', changeEvent);
        };
    }, [id, isCart, setProductPage, variantInput, variants]);
    useEffect(() => {
        var _a, _b, _c, _d;
        let inputs = {};
        let units = [];
        let areaFieds = [];
        if (isPool) {
            const length = MmToCm(parseFloat((_a = product.metafields['SB-P']['Length']) !== null && _a !== void 0 ? _a : '1'));
            const width = MmToCm(parseFloat((_b = product.metafields['SB-P']['Width']) !== null && _b !== void 0 ? _b : '1'));
            units.push(...[
                {
                    factor: 'Width',
                    factorValue: 1,
                    key: 'Width',
                    perQuantity: length,
                    unit: 'Width',
                    unitValue: 'Width',
                    hideButtons: true,
                },
                {
                    factor: 'Length',
                    factorValue: 1,
                    key: 'Length',
                    perQuantity: length,
                    unit: 'Length',
                    unitValue: 'Length',
                    hideButtons: true,
                },
                {
                    factor: 'PCE',
                    factorValue: 1,
                    key: 'PCE',
                    perQuantity: 1,
                    unit: 'PCE',
                    unitValue: 'PCE',
                    hideButtons: true,
                },
            ]);
            inputs = {
                Width: width,
                Length: length,
                PCE: Math.max(quantity, minimumQuantity),
            };
        }
        else if (isBags) {
            areaFieds.push(...[
                {
                    factor: 'Width',
                    factorValue: 1,
                    key: 'Width',
                    perQuantity: 1,
                    unit: 'Width',
                    unitValue: 'Width',
                    hideButtons: true,
                },
                {
                    factor: 'Length',
                    factorValue: 1,
                    key: 'Length',
                    perQuantity: 1,
                    unit: 'Length',
                    unitValue: 'Length',
                    hideButtons: true,
                },
                {
                    factor: 'Thickness',
                    factorValue: 1,
                    key: 'Thickness',
                    perQuantity: 1,
                    unit: 'Thickness',
                    unitValue: 'Thickness',
                    hideButtons: true,
                },
                {
                    factor: 'M3',
                    factorValue: 1,
                    key: 'M3',
                    perQuantity: 1,
                    unit: 'M3',
                    unitValue: 'M3',
                },
                {
                    factor: 'PCE',
                    factorValue: 1,
                    key: 'PCE',
                    perQuantity: 1,
                    unit: 'PCE',
                    unitValue: 'PCE',
                },
            ]);
            const m3 = (quantity * bagSize) / bagDensity;
            // AreaWidth	AreaLength	AreaThickness
            inputs = {
                Width: 1,
                Length: 1,
                Thickness: 1,
                M3: RoundOff(m3),
                PCE: quantity,
            };
        }
        else if (isStair) {
            units = ExtractUnits(product.metafields['SB-P']);
            units.push(...[
                {
                    factor: 'Height',
                    factorValue: 1,
                    key: 'Height',
                    perQuantity: 1,
                    unit: 'Height',
                    unitValue: 'Height',
                    hideButtons: true,
                },
                {
                    factor: 'Length',
                    factorValue: 1,
                    key: 'Length',
                    perQuantity: 1,
                    unit: 'Length',
                    unitValue: 'Length',
                    hideButtons: true,
                },
            ]);
            inputs = GenerateInputsBaseFromUnits(units, quantity);
            const height = MmToCm(parseFloat((_c = product.metafields['SB-P']['Thickness']) !== null && _c !== void 0 ? _c : '1'));
            const width = MmToCm(parseFloat((_d = product.metafields['SB-P']['Width']) !== null && _d !== void 0 ? _d : '1'));
            inputs.Length = quantity * (width - 3);
            inputs.Height = quantity * height;
        }
        else {
            units = ExtractUnits(product.metafields['SB-P']);
            inputs = GenerateInputsBaseFromUnits(units, quantity);
        }
        if (inputs['PCE'] !== undefined) {
            inputs['PCE'] = Math.max(quantity, minimumQuantity);
        }
        const indexOfPce = units.findIndex((f) => f.key === 'PCE');
        if (indexOfPce > -1) {
            units[indexOfPce].minimumQuantity = minimumQuantity;
        }
        setState(produce((previousState) => {
            previousState.qty = quantity;
            previousState.rawQuantity = quantity;
            previousState.fields = units;
            previousState.inputs = inputs;
            previousState.areaFieds = areaFieds;
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, product, extraProducts, minimumQuantity]);
    const onSelectedPoolCorner = useCallback((ids) => {
        if (extra_product_pool_corner) {
            const pool_selected = ids.length > 0 ? ids.includes(extra_product_pool_corner.variant_id) : false;
            setSelectedPoolCorner(pool_selected);
            setState(produce((previousState) => {
                const newQty = CalculatePoolQuantity(previousState.inputs, product, extra_product_pool_corner, pool_selected);
                previousState.inputs['PCE'] = newQty;
                previousState.qty = Math.ceil(newQty);
                previousState.rawQuantity = newQty;
            }));
            setSelectedPoolCorners(ids);
        }
    }, [extra_product_pool_corner, product]);
    const changeValues = useCallback((key, value) => {
        setState(produce((previousState) => {
            var _a, _b;
            const unit = isBags ? previousState.areaFieds.filter((f) => f.key === key)[0] : previousState.fields.filter((f) => f.key === key)[0];
            let newQty = 1;
            if (isPool) {
                previousState.inputs[key] = value;
                newQty = Math.ceil(value / unit.perQuantity);
                if (key === 'Length' || key === 'Width') {
                    newQty = CalculatePoolQuantity(previousState.inputs, product, extra_product_pool_corner, selectedPoolCorner);
                    previousState.inputs.PCE = newQty;
                }
            }
            else if (isBags) {
                previousState.inputs[key] = value;
                if (key === 'Width' || key === 'Thickness' || key === 'Length') {
                    const area = previousState.inputs['Width'] * previousState.inputs['Length'] * previousState.inputs['Thickness'];
                    const m3 = area / 1000000;
                    const quantity = (m3 * bagDensity) / bagSize;
                    previousState.inputs.M3 = RoundOff(m3);
                    newQty = quantity;
                    previousState.inputs.PCE = newQty;
                }
                else if (key === 'M3') {
                    const quantity = (value * bagDensity) / bagSize;
                    previousState.inputs.M3 = value;
                    newQty = quantity;
                    previousState.inputs.PCE = newQty;
                }
                else if (key === 'PCE') {
                    const m3 = (value * bagSize) / bagDensity;
                    previousState.inputs.M3 = RoundOff(m3);
                    newQty = value;
                    previousState.inputs.PCE = newQty;
                }
            }
            else if (isStair) {
                previousState.inputs[key] = value;
                const height = MmToCm(parseFloat((_a = product.metafields['SB-P']['Thickness']) !== null && _a !== void 0 ? _a : '1'));
                const width = MmToCm(parseFloat((_b = product.metafields['SB-P']['Width']) !== null && _b !== void 0 ? _b : '1'));
                const current_length = previousState.inputs['Length'];
                const current_height = previousState.inputs['Height'];
                switch (key) {
                    case 'Length':
                        const length_pce = current_length / (width - 3);
                        newQty = length_pce;
                        previousState.inputs.Height = newQty * height;
                        break;
                    case 'Height':
                        const height_pce = current_height / height;
                        newQty = height_pce;
                        previousState.inputs.Length = newQty * (width - 3);
                        break;
                    case 'DEFAULT':
                        newQty = value / unit.perQuantity;
                        previousState.inputs.Length = newQty * (width - 3);
                        previousState.inputs.Height = newQty * height;
                        break;
                    case 'EXTRA':
                        newQty = value / unit.perQuantity;
                        previousState.inputs.Length = newQty * (width - 3);
                        previousState.inputs.Height = newQty * height;
                        break;
                }
                previousState.inputs['DEFAULT'] = newQty;
                if (previousState.inputs['EXTRA'] !== undefined) {
                    const currentUnit = previousState.fields.filter((f) => f.key === 'EXTRA')[0];
                    previousState.inputs['EXTRA'] = RoundOff(newQty * currentUnit.perQuantity);
                }
            }
            else {
                newQty = value / unit.perQuantity;
                for (const inputKey in previousState.inputs) {
                    const unit = previousState.fields.filter((f) => f.key === inputKey)[0];
                    previousState.inputs[inputKey] = inputKey === key ? value : RoundOff(newQty * unit.perQuantity);
                }
            }
            // // Enforce minimum quantity
            // newQty = Math.max(newQty, minimumQuantity);
            previousState.qty = Math.ceil(newQty);
            previousState.rawQuantity = newQty;
        }));
    }, [bagDensity, bagSize, extra_product_pool_corner, isBags, isPool, isStair, product, selectedPoolCorner]);
    const handleInputChange = useCallback((key, currentVal) => {
        var _a;
        const value = parseFloat((_a = currentVal === null || currentVal === void 0 ? void 0 : currentVal.toString()) !== null && _a !== void 0 ? _a : '0');
        changeValues(key, value);
    }, [changeValues]);
    const handleButtonAction = useCallback((key, action) => {
        var _a, _b;
        const value = GetValueByAction(parseFloat((_b = (_a = inputs[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '0'), action);
        // Don't allow zero or negative values
        const effectiveValue = Math.max(value, action === 'subtract' ? 0.1 : value);
        changeValues(key, effectiveValue);
    }, [changeValues, inputs]);
    const { pallet, pallet_qty, total_weight_qty, breaking_pallet, breaking_pallet_qty, tipping, tipping_qty } = GetProductPalletValues(id, qty);
    useEffect(() => {
        setState(produce((previousState) => {
            previousState.pallets = pallet_qty || (total_weight_qty !== null && total_weight_qty !== void 0 ? total_weight_qty : 0);
            previousState.breakingPallets = breaking_pallet_qty;
            previousState.tippings = tipping_qty;
        }));
    }, [pallet_qty, breaking_pallet_qty, total_weight_qty, tipping_qty]);
    useEffect(() => {
        const productTotal = price * rawQuantity;
        const format = isCart ? settings.money_format : settings.money_format.replace('amount_no_decimals', 'amount');
        const formatedMoney = FormatMoney(productTotal, format);
        setTotalDisplay(formatedMoney);
        const qtyInput = jQuery('#product-quantity-input');
        qtyInput.val(qty);
        qtyInput.trigger('change');
        if (!isCart) {
            const form = qtyInput.closest('form');
            const button = form.find('button[data-product-atc]');
            const valid = CartService.CheckMinimumQuantity(product, qty);
            if (!valid.isValid) {
                button.attr('disabled', 'disabled');
                button.addClass('disabled');
            }
            else {
                button.removeAttr('disabled');
                button.removeClass('disabled');
            }
            setProductPage((state) => {
                state.quantity = qty;
            });
        }
    }, [rawQuantity, qty, product, settings, price, pallets, breakingPallets, withPallets, setProductPage, isCart, minimumQuantity]);
    useEffect(() => {
        if (inputChange && !initialLoad.current) {
            inputChange(qty);
        }
        const handleInputChangeDebounce = () => {
            if (inputChangeDebounce && !initialLoad.current) {
                inputChangeDebounce(qty);
            }
        };
        const callBackChangeHandler = debounce(handleInputChangeDebounce, IsMobile() ? 2500 : 1500);
        if (!initialLoad.current) {
            callBackChangeHandler();
        }
        initialLoad.current = false;
        return () => {
            callBackChangeHandler.cancel();
        };
    }, [qty, inputChange, inputChangeDebounce]);
    const palletsFormatedMoneyTotalDisplay = FormatMoney(pallet.price * pallets, settings.money_format);
    const palletsBreakingFormatedMoneyTotalDisplay = FormatMoney(breaking_pallet.price * breakingPallets, settings.money_format);
    const tippingFormatedMoneyTotalDisplay = FormatMoney(tipping.price * tippings, settings.money_format);
    const tippingComponent = (_jsxs("div", Object.assign({ className: clsx('pallets', {
            show: tippings,
        }) }, { children: [_jsxs("div", Object.assign({ className: 'pallet-title' }, { children: [tipping.title, " ", HasVatDisplay && _jsxs("sup", { children: ["(", settings.translations.product.excluded_vat, ")"] })] })), _jsx("div", Object.assign({ className: 'pallet-total' }, { children: tippingFormatedMoneyTotalDisplay }))] })));
    const breakingPalletsComponent = (_jsxs("div", Object.assign({ className: clsx('pallets', {
            show: breakingPallets,
        }) }, { children: [_jsxs("div", Object.assign({ className: 'pallet-title' }, { children: [breaking_pallet.title, " ", HasVatDisplay && _jsxs("sup", { children: ["(", settings.translations.product.excluded_vat, ")"] })] })), _jsx("div", Object.assign({ className: 'pallet-total' }, { children: palletsBreakingFormatedMoneyTotalDisplay }))] })));
    const palletsComponent = (_jsxs("div", Object.assign({ className: clsx('pallets', {
            show: pallets,
        }) }, { children: [_jsxs("div", Object.assign({ className: 'pallet-title' }, { children: [pallet.title, " ", HasVatDisplay && _jsxs("sup", { children: ["(", settings.translations.product.excluded_vat, ")"] })] })), _jsx("div", Object.assign({ className: 'pallet-total' }, { children: palletsFormatedMoneyTotalDisplay }))] })));
    const palletsWrapper = (_jsxs("div", Object.assign({ className: 'pallets-wrapper' }, { children: [(!!pallets || !!breakingPallets || !!tippings) && (_jsx("h5", Object.assign({ style: { marginBottom: 10, marginTop: 0 } }, { children: settings.translations.product.packaging_and_handling }))), palletsComponent, breakingPalletsComponent, tippingComponent] })));
    let DisplayTotal = (_jsxs(_Fragment, { children: [isCart && HasVatDisplay && _jsxs("sup", Object.assign({ className: 'product-vat' }, { children: [settings.translations.product.included_vat, " :"] })), _jsx("span", { children: totalDisplay }), !isCart && HasVatDisplay && _jsx("small", Object.assign({ className: 'product-vat' }, { children: settings.translations.product.excluded_vat }))] }));
    if (isCart) {
        DisplayTotal = (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: 'product-add-total--without-vat' }, { children: [HasVatDisplay && _jsxs("sup", Object.assign({ className: 'product-vat' }, { children: [settings.translations.product.excluded_vat, " :"] })), _jsx("span", { children: totalDisplay })] })) }));
    }
    if (!Object.keys(inputs).length) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [variantChangeLoading && (_jsxs(_Fragment, { children: [_jsx(LinearProgress, { color: 'primary', sx: {
                            position: 'absolute',
                            width: '100%',
                            top: 0,
                            left: 0,
                            zIndex: 50,
                        } }), _jsx(LinearProgress, { color: 'primary', sx: {
                            position: 'absolute',
                            width: '100%',
                            bottom: 0,
                            left: 0,
                            zIndex: 50,
                        } }), _jsx(CircularProgress, { sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 9999,
                        } })] })), _jsx("input", { type: 'hidden', name: 'product[properties][_type]', value: type, "aria-labelledby": 'Form type' }), _jsxs("div", Object.assign({ className: clsx('product-input-container-wrapper', {
                    'wrapper-pool': isPool,
                    'wrapper-bag': isBags,
                    'wrapper-stair': isStair,
                }) }, { children: [!is_sample && fields.length > 0 && isStair && (_jsx("div", Object.assign({ className: clsx('product-input-container stair') }, { children: fields
                            .filter((f) => f.key === 'Length' || f.key === 'Height')
                            .map(({ key, unitValue, hideButtons }) => {
                            const inputId = `product[properties][${unitValue}]`;
                            const input_cart_value = RoundOff(inputs[key]);
                            return (_jsx(FormInput, { id: inputId, field: key, unit: unitValue, value: input_cart_value === null || input_cart_value === void 0 ? void 0 : input_cart_value.toString(), loading: loading, isCart: isCart, onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur, hideButtons: hideButtons }, key));
                        }) }))), !is_sample && fields.length > 0 && (_jsx("div", Object.assign({ className: clsx('product-input-container', {
                            pool: isPool,
                        }) }, { children: fields
                            .filter((f) => (f.unit !== 'PCE' || !isPool || isCart) && (!isStair || (isStair && !(f.key === 'Length' || f.key === 'Height'))))
                            .map(({ key, unitValue, factorValue, hideButtons, minimumQuantity }) => {
                            const inputId = `product[properties][${unitValue}]`;
                            const input_cart_value = RoundOff(inputs[key]);
                            return (_jsx(FormInput, { id: inputId, field: key, unit: unitValue, value: input_cart_value === null || input_cart_value === void 0 ? void 0 : input_cart_value.toString(), loading: loading, isCart: isCart, price: isPool ? undefined : price, factorValue: isPool ? undefined : factorValue, onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur, hideButtons: hideButtons, minimumQuantity: minimumQuantity }, key));
                        }) }))), isPool && !is_sample && fields.length > 0 && !isCart && (_jsx("div", Object.assign({ className: 'product-input-container pool' }, { children: fields
                            .filter((f) => f.unit === 'PCE')
                            .map(({ key, unitValue, factorValue, hideButtons, minimumQuantity }) => {
                            const inputId = `product[properties][${unitValue}]`;
                            const input_cart_value = RoundOff(inputs[key]);
                            return (_jsx(FormInput, { id: inputId, field: key, unit: unitValue, value: input_cart_value === null || input_cart_value === void 0 ? void 0 : input_cart_value.toString(), loading: loading, isCart: isCart, price: price, factorValue: factorValue, onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur, hideButtons: hideButtons, minimumQuantity: minimumQuantity }, key));
                        }) }))), !is_sample && areaFieds.length > 0 && (_jsxs(_Fragment, { children: [!isCart && (_jsx("div", Object.assign({ className: 'product-input-container' }, { children: areaFieds
                                    .filter((f) => f.key !== 'PCE' && f.key !== 'M3')
                                    .map(({ key, unitValue, factorValue, hideButtons, minimumQuantity }) => {
                                    const inputId = `product[properties][${unitValue}]`;
                                    const input_cart_value = RoundOff(inputs[key]);
                                    return (_jsx(FormInput, { id: inputId, field: key, unit: unitValue, value: input_cart_value === null || input_cart_value === void 0 ? void 0 : input_cart_value.toString(), loading: loading, isCart: isCart, price: isBags ? undefined : price, factorValue: isBags ? undefined : factorValue, onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur, hideButtons: hideButtons, minimumQuantity: minimumQuantity }, key));
                                }) }))), _jsxs("div", Object.assign({ className: 'product-input-container' }, { children: [_jsx(FormInput, { id: 'input-M3', field: 'M3', unit: 'M3', value: (_c = RoundOff(inputs['M3'])) === null || _c === void 0 ? void 0 : _c.toString(), loading: loading, isCart: isCart, className: 'not-equal', price: price, factorValue: 1 / (bagSize / bagDensity), onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur }), !isCart && _jsx("div", Object.assign({ className: 'product-input-wrapper not-equal no-item' }, { children: "\u00A0" })), _jsx(FormInput, { id: 'input-PCE', field: 'PCE', unit: 'PCE', value: (_d = RoundOff(inputs['PCE'])) === null || _d === void 0 ? void 0 : _d.toString(), loading: loading, isCart: isCart, price: price, factorValue: 1, className: 'not-equal', onChange: handleInputChange, onButtonClick: handleButtonAction, onBlur: onBlur, minimumQuantity: minimumQuantity })] }))] })), is_sample && (_jsxs("div", Object.assign({ className: 'product-input-container' }, { children: [settings.translations.product.quantity, ": ", quantity] })))] })), _jsxs("div", Object.assign({ className: 'total-wrapper' }, { children: [_jsx("div", Object.assign({ style: { fontSize: 25 } }, { children: "Pris" })), _jsx("div", Object.assign({ className: 'product-add-total' }, { children: DisplayTotal }))] })), palletsWrapper, !!extra_product_pool_corner && !isCart && (_jsxs("div", Object.assign({ className: 'extra-products--wrapper' }, { children: [_jsx("h5", Object.assign({ className: 'extra-products--header' }, { children: settings.translations.product.pool_calculator })), _jsx(ExtraProduct, { extra_products: extra_product_pool_corners, qty: qty, settings: settings, center_display: true, replace_title: settings.translations.product.pool_corner_title, display_price: selectedPoolCorner, onSelected: onSelectedPoolCorner, selected_items: selectedPoolCorners })] }))), !isCart && _jsx(ExtraProductDisplay, { extra_products: extra_products, qty: qty, settings: settings }), children] }));
};
export default ProductInput;
